/**
 * @author        yontaek@zumper.com (Yon Taek Chung)
 * @copyright     Copyright (c) 2023, Zumper
 * @description   getVisitedExperiment for optimizely experiments
 */

import type { OptimizelyClient } from './optimizelyClient'

export const getVisitedExperiments = (
  optimizelyClient: OptimizelyClient | null | undefined
) => {
  const visitedExperiments: { [key: string]: string } = {}
  if (!optimizelyClient) {
    return visitedExperiments
  }
  const { experimentsMap } = optimizelyClient.getOptimizelyConfig() ?? {}
  const variationsMap = optimizelyClient.exportVariationMap()
  const userId = optimizelyClient.user?.id
  const allActiveExperiments = Object.values(experimentsMap ?? {})
  const activatedExperiments =
    // @ts-expect-error
    optimizelyClient.initialConfig?.userProfileService?.lookup(userId) ?? {}

  const missingActivatedExperiments = new Map<
    string,
    { variation_id: string }
  >()

  for (const { id, key, variationsMap: variations } of allActiveExperiments) {
    if (key) {
      if (activatedExperiments[id]) {
        visitedExperiments[key] = variationsMap[key]
      } else if (optimizelyClient.activatedExperiments.has(key)) {
        const variation_id = variations[variationsMap[key]]?.id
        if (variation_id) {
          missingActivatedExperiments.set(id, {
            variation_id,
          })
        }
        visitedExperiments[key] = variationsMap[key]
      }
    }
  }

  if (missingActivatedExperiments.size) {
    // @ts-expect-error
    optimizelyClient.initialConfig?.userProfileService?.save(
      {
        experiment_bucket_map: Object.fromEntries(
          missingActivatedExperiments.entries()
        ),
        user_id: userId,
      },
      true
    )
  }

  return visitedExperiments
}
